import React from 'react';
import { Menu, Text, useMantineColorScheme } from '@mantine/core';
import {
  IconSun,
  IconMoon,
  IconDeviceDesktop,
  IconChevronRight,
  IconPalette,
} from '@tabler/icons-react';

type ThemeMode = 'light' | 'dark' | 'auto';

interface ThemeOption {
  value: ThemeMode;
  label: string;
  icon: React.ReactNode;
}

const THEME_OPTIONS: ThemeOption[] = [
  {
    value: 'light',
    label: 'Light mode',
    icon: <IconSun size={18} />,
  },
  {
    value: 'dark',
    label: 'Dark mode',
    icon: <IconMoon size={18} />,
  },
  {
    value: 'auto',
    label: 'Match browser',
    icon: <IconDeviceDesktop size={18} />,
  },
];

export function ThemeMenuItems(): JSX.Element {
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  return (
    <Menu.Item closeMenuOnClick={false}>
      <Menu position="right-start" shadow="md" width={200} trigger="hover">
        <Menu.Target>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <IconPalette size={18} />
              <Text size="sm">Appearance</Text>
            </div>
            <IconChevronRight size={14} />
          </div>
        </Menu.Target>

        <Menu.Dropdown>
          {THEME_OPTIONS.map(option => (
            <Menu.Item
              key={option.value}
              leftSection={React.cloneElement(
                option.icon as React.ReactElement,
                {
                  size: 18,
                }
              )}
              onClick={() => setColorScheme(option.value)}
              style={{
                backgroundColor:
                  colorScheme === option.value
                    ? 'var(--mantine-color-blue-light)'
                    : undefined,
              }}
            >
              <Text size="sm" fw={colorScheme === option.value ? 600 : 400}>
                {option.label}
              </Text>
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
    </Menu.Item>
  );
}
